import { inject, Injectable } from '@angular/core';
import { VideoInfo } from './api-types';
import { VideoApiService } from './video-api-service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  private api = inject(VideoApiService);

  async getVideoInfo(id: string): Promise<VideoInfo> {
    const result = (await this.api.call('get',`video/${id}`, {})) as VideoInfo;
    return result;
  }
  
  // async getBase64Key(id: string): Promise<string> {
  //   const key = (await this.api.call('get',`key64/${id}`, {})) as string;
  //   return key;
  // }

}

